import { LightbulbMultipleOffIcon } from './LightbulbMultipleOffIcon';

/**
 * author: Michael Irigoyen
 * id B336C5E4-48AB-4620-9DA4-DB1144885F7C
 * name lightbulb-multiple-off
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightbulb-multiple-off.svg
 * tags
 * - Home Automation 
 */
export const BulbsOffIcon = LightbulbMultipleOffIcon;
export default BulbsOffIcon